import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { LectionaryItemName, LectionaryItemNameSummary, LectionaryItemNameService } from '../../services/lectionary-item-name.service';
import { LectionaryItemNameEditComponent } from '../lectionary-item-name-edit/lectionary-item-name-edit.component';
import { LectionaryItemType } from '../../services/lectionary-item-type.service';

@Component({
  selector: 'app-lectionary-item-name',
  templateUrl: './lectionary-item-name.component.html',
  styleUrls: ['./lectionary-item-name.component.css']
})
export class LectionaryItemNameComponent implements OnInit {

  public entities: LectionaryItemNameSummary[];
  public isLoading = false;
  public search: string;

  constructor(
    public dialog: MatDialog,
    public lectionaryItemNameSvc: LectionaryItemNameService,
    private apiSvc: ApiService
  ) { }

  ngOnInit() {
    this.loadEntities();
  }

  private loadEntities() {
    this.isLoading = true;
    this.lectionaryItemNameSvc.loadSummaryEntities().then(
      (data: LectionaryItemNameSummary[]) => {

        this.PrepareSearch(data);

        this.entities = data;
        console.log(this.entities);   

        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        console.log("error", err);
      }
    );
}
 
private PrepareSearch(items: LectionaryItemNameSummary[]): void {
 
    items.forEach(item => {
       
      var availableSearchTerms: string[] = []; 

      // Set search terms for angular
      availableSearchTerms.push(item.Name);
      availableSearchTerms.push(item.LectionaryItemType);

      item.AvailableSearchTerms = availableSearchTerms; 
    });

}


public edit(obj: LectionaryItemNameSummary) {

  var modal = this.dialog.open(LectionaryItemNameEditComponent);
  modal.componentInstance.LoadItem(obj.Id);

  modal.afterClosed().subscribe((savedItem: LectionaryItemName) => {

    console.log("modal closed", savedItem);

    //TODO, call the API to update this single record instead of manually changing the fields
    if (savedItem !== undefined) {
      obj.Name = savedItem.Localized[0].Name
      obj.LectionaryItemType = savedItem.LectionaryItemType.Localized[0].Name;
    }

  });

}



public add() {

  var modal = this.dialog.open(LectionaryItemNameEditComponent);
  modal.componentInstance.LoadItem(null);

  modal.afterClosed().subscribe((savedItem: LectionaryItemName) => {

    console.log("modal closed", savedItem);

    if (savedItem !== undefined) { 
      this.loadEntities();
    }

  });

}
 
public delete(entity: LectionaryItemNameSummary) { 
   console.log("Delete", entity);

   this.lectionaryItemNameSvc.delete(entity.Id).then(
    () => { 
      console.log("Done");     
      this.loadEntities();
    },
    (err) => {
      this.isLoading = false;
      console.log("error", err);

      if (err.status == 406) {  
        var errorReason = JSON.parse(err._body).reason; 
        alert("Error: " + errorReason);
      } else {
        var errorReason = JSON.parse(err._body).reason; 
        if (errorReason != undefined) {
          alert("Error: " + errorReason);
        }
        else { 
          alert("Cannot delete the LectionaryItemName");
        }
      }

    }
  );
}
 

}

